module.exports = __webpack_public_path__ + "img/firtst.8a890afb.png";